import { ensureJourneyDb, listTable } from "../db";
import { addSuggestion as hubAddSuggestion, listSuggestions as hubListSuggestions } from "./suggestions";

const MSG_KEY = "dh_admin_broker_messages";

export function listBrokers() {
  ensureJourneyDb();
  return listTable("users")
    .filter((row) => row.role_type === "broker")
    .map((row) => ({
      id: row.id,
      name: row.name || "",
      email: row.email || "",
      phone: row.phone || "",
      office_name: row.office_name || "",
    }));
}

export function listAgentsForAdmin() {
  ensureJourneyDb();
  return listTable("users")
    .filter((row) => row.role_type === "agent")
    .map((row) => ({
      id: row.id,
      name: row.name || "",
      email: row.email || "",
    }));
}

function read(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null") ?? fallback;
  } catch {
    return fallback;
  }
}

function write(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function listSuggestions() {
  return hubListSuggestions();
}

export function addSuggestion({ text, from_name, from_role, from_user_id, category }) {
  return hubAddSuggestion({ text, from_name, from_role, from_user_id, category });
}

export function listAdminBrokerMessages() {
  return read(MSG_KEY, []).sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
}

export function sendAdminBrokerMessage({ to_user_id, to_name, to_email, text, from_name }) {
  const row = {
    id: crypto.randomUUID(),
    to_user_id,
    to_name,
    to_email,
    text: String(text || "").trim(),
    from_name: from_name || "Site admin",
    created_at: new Date().toISOString(),
  };
  write(MSG_KEY, [row, ...listAdminBrokerMessages()]);
  return row;
}
